import "./svg/webshop.svg"

export default {
    name: "webshop",
    viewBox: "54 32",
}
